import React from "react";
// import styles from "./Questions.module.sass";
// import TooltipGlobal from "../../components/TooltipGlobal";
import Faq from "./Faq";

const Questions = () => {
    return (
        <>
            <Faq />
        </>
    );
};

export default Questions;
